import {
  ApiGetRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
  // ApiPostMultipart,
  ApiBlobGetRequest,
} from '../../api';
// import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Laporan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Laporan',
        href: '/adm/laporan',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_sales',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'tgl_jual',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'code_jual',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'dist_name',
        label: 'Distributor',
        sortable: true,
      },
      {
        key: 'cust_name',
        label: 'Customer',
        sortable: true,
      },
      {
        key: 'prod_name',
        label: 'Produk',
      },
      {
        key: 'item_price',
        label: 'Harga',
      },
      {
        key: 'item_qty',
        label: 'Qty',
      },
      {
        key: 'item_total',
        label: 'Total',
      },
    ],
    detail: false,
    form: {},
    import_form: [],
    loading_dist: false,
    top_dist: [],
    loading_prod: false,
    top_prod: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  detail(state) {
    return state.data.detail;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeLaporan(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchLaporan(context, params = null) {
    let result = await ApiGetRequest(`laporan`, params);
    return !result.error ? result.data.object : [];
  },

  async getListLaporan({ commit, state }, payload = {}) {
    commit('changeLaporan', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      id_distributor: data.id_distributor ? data.id_distributor : '',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`laporan/distributor`, params);
      commit('changeLaporan', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_laporan.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`laporan/distributor`, params);
      commit('changeLaporan', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getTopDist({ commit }, payload = {}) {
    commit('changeLaporan', {
      loading_dist: true,
    });

    let params = {
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`laporan/top-distributor`, params);
    commit('changeLaporan', {
      top_dist: !result.error ? result.data.object : [],
      loading_dist: false,
    });

    return !result.error ? true : false;
  },

  async getTopProd({ commit }, payload = {}) {
    commit('changeLaporan', {
      loading_prod: true,
    });

    let params = {
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`laporan/top-product`, params);
    commit('changeLaporan', {
      top_prod: !result.error ? result.data.object : [],
      loading_prod: false,
    });

    return !result.error ? true : false;
  },
};
